"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareFormButtonPopupImageUrl = exports.ShareFormEmbedImageUrl = exports.ShareFormLinkedButtonImageUrl = exports.TipRefundWithZeffyImageUrl = exports.TipRefundTipModalImageUrl = exports.TipRefundHero100FreeImageUrl = exports.NewsletterCrossSellImageUrl = exports.FromScratchEmailTemplatePreviewSvgUrl = exports.getRegisterDefaultBackgroundImageUrl = exports.getRegisterCategoryBackgroundImageUrl = exports.getMobileFormPreviewUrl = exports.getDesktopFormPreviewUrl = exports.MembershipSquareDefaultBannerUrl = exports.RaffleSquareDefaultBannerUrl = void 0;
const common_1 = require("../../enums/common");
const locales_1 = require("../enums/locales");
exports.RaffleSquareDefaultBannerUrl = {
    [locales_1.Locales.EN]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067062/default-banners/raffleSquareDefaultBannerV2-en.jpg",
    [locales_1.Locales.FR]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067064/default-banners/raffleSquareDefaultBannerV2-fr.jpg",
    [locales_1.Locales.ES]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067064/default-banners/raffleSquareDefaultBannerV2-fr.jpg",
    [locales_1.Locales.DE]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067064/default-banners/raffleSquareDefaultBannerV2-fr.jpg",
};
exports.MembershipSquareDefaultBannerUrl = {
    [locales_1.Locales.EN]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067060/default-banners/membershipSquareDefaultBannerV2-en.jpg",
    [locales_1.Locales.FR]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067061/default-banners/membershipSquareDefaultBannerV2-fr.jpg",
    [locales_1.Locales.ES]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067061/default-banners/membershipSquareDefaultBannerV2-fr.jpg",
    [locales_1.Locales.DE]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067061/default-banners/membershipSquareDefaultBannerV2-fr.jpg",
};
const CLOUDINARY_BASE_DESKTOP = "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto:best/v1778067108/features/live-form-editor/desktop";
const CLOUDINARY_BASE_MOBILE = "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067088/features/live-form-editor/mobile";
const DESKTOP_FORM_PREVIEW_SLUGS = {
    [locales_1.Locales.EN]: {
        [common_1.FormCategory.Event]: "event-form-desktop-preview-en.webp",
        [common_1.FormCategory.DonationForm]: "donation-form-desktop-preview-en.webp",
        [common_1.FormCategory.MembershipV2]: "membership-form-desktop-preview-en.webp",
        [common_1.FormCategory.PeerToPeerCampaign]: "p2p-form-desktop-preview-en.webp",
        [common_1.FormCategory.Custom]: "custom-form-desktop-preview-en.webp",
        [common_1.FormCategory.Lottery]: "raffle-form-desktop-preview-en.webp",
        [common_1.FormCategory.Sweepstakes]: "Sweepstakes-Desktop.webp",
        [common_1.FormCategory.Auction]: "auction-form-desktop-preview-en.webp",
        [common_1.FormCategory.Shop]: "shop-form-desktop-preview-en.webp",
    },
    [locales_1.Locales.DE]: {
        [common_1.FormCategory.Event]: "event-form-desktop-preview-de.webp",
        [common_1.FormCategory.DonationForm]: "donation-form-desktop-preview-de.webp",
        [common_1.FormCategory.MembershipV2]: "membership-form-desktop-preview-de.webp",
        [common_1.FormCategory.PeerToPeerCampaign]: "p2p-form-desktop-preview-de.webp",
        [common_1.FormCategory.Custom]: "custom-form-desktop-preview-de.webp",
        [common_1.FormCategory.Lottery]: "raffle-form-desktop-preview-de.webp",
        [common_1.FormCategory.Sweepstakes]: "Sweepstakes-Desktop-DE.webp",
        [common_1.FormCategory.Auction]: "auction-form-desktop-preview-de.webp",
        [common_1.FormCategory.Shop]: "shop-form-desktop-preview-de.webp",
    },
    [locales_1.Locales.ES]: {
        [common_1.FormCategory.Event]: "event-form-desktop-preview-en.webp",
        [common_1.FormCategory.DonationForm]: "donation-form-desktop-preview-en.webp",
        [common_1.FormCategory.MembershipV2]: "membership-form-desktop-preview-en.webp",
        [common_1.FormCategory.PeerToPeerCampaign]: "p2p-form-desktop-preview-en.webp",
        [common_1.FormCategory.Custom]: "custom-form-desktop-preview-en.webp",
        [common_1.FormCategory.Lottery]: "raffle-form-desktop-preview-en.webp",
        [common_1.FormCategory.Sweepstakes]: "Sweepstakes-Desktop-ES.webp",
        [common_1.FormCategory.Auction]: "auction-form-desktop-preview-en.webp",
        [common_1.FormCategory.Shop]: "shop-form-desktop-preview-en.webp",
    },
    [locales_1.Locales.FR]: {
        [common_1.FormCategory.Event]: "event-form-desktop-preview-fr.webp",
        [common_1.FormCategory.DonationForm]: "donation-form-desktop-preview-fr.webp",
        [common_1.FormCategory.MembershipV2]: "membership-form-desktop-preview-fr.webp",
        [common_1.FormCategory.PeerToPeerCampaign]: "p2p-form-desktop-preview-fr.webp",
        [common_1.FormCategory.Custom]: "custom-form-desktop-preview-fr.webp",
        [common_1.FormCategory.Lottery]: "raffle-form-desktop-preview-fr.webp",
        [common_1.FormCategory.Sweepstakes]: "Sweepstakes-Desktop-FR.webp",
        [common_1.FormCategory.Auction]: "auction-form-desktop-preview-fr.webp",
        [common_1.FormCategory.Shop]: "shop-form-desktop-preview-fr.webp",
    },
};
const MOBILE_FORM_PREVIEW_SLUGS = {
    [locales_1.Locales.EN]: {
        [common_1.FormCategory.Event]: "event-form-mobile-preview-en.webp",
        [common_1.FormCategory.DonationForm]: "donation-form-mobile-preview-en.webp",
        [common_1.FormCategory.MembershipV2]: "membership-form-mobile-preview-en.webp",
        [common_1.FormCategory.PeerToPeerCampaign]: "p2p-form-mobile-preview-en.webp",
        [common_1.FormCategory.Custom]: "custom-form-mobile-preview-en.webp",
        [common_1.FormCategory.Lottery]: "raffle-form-mobile-preview-en.webp",
        [common_1.FormCategory.Sweepstakes]: "Sweepstakes.webp",
        [common_1.FormCategory.Auction]: "auction-form-mobile-preview-en.webp",
        [common_1.FormCategory.Shop]: "shop-form-mobile-preview-en.webp",
    },
    [locales_1.Locales.DE]: {
        [common_1.FormCategory.Event]: "event-form-mobile-preview-de.webp",
        [common_1.FormCategory.DonationForm]: "donation-form-mobile-preview-de.webp",
        [common_1.FormCategory.MembershipV2]: "membership-form-mobile-preview-de.webp",
        [common_1.FormCategory.PeerToPeerCampaign]: "p2p-form-mobile-preview-de.webp",
        [common_1.FormCategory.Custom]: "custom-form-mobile-preview-de.webp",
        [common_1.FormCategory.Lottery]: "raffle-form-mobile-preview-de.webp",
        [common_1.FormCategory.Sweepstakes]: "SweepstakesDE.webp",
        [common_1.FormCategory.Auction]: "auction-form-mobile-preview-de.webp",
        [common_1.FormCategory.Shop]: "shop-form-mobile-preview-de.webp",
    },
    [locales_1.Locales.ES]: {
        [common_1.FormCategory.Event]: "event-form-mobile-preview-en.webp",
        [common_1.FormCategory.DonationForm]: "donation-form-mobile-preview-en.webp",
        [common_1.FormCategory.MembershipV2]: "membership-form-mobile-preview-en.webp",
        [common_1.FormCategory.PeerToPeerCampaign]: "p2p-form-mobile-preview-en.webp",
        [common_1.FormCategory.Custom]: "custom-form-mobile-preview-en.webp",
        [common_1.FormCategory.Lottery]: "raffle-form-mobile-preview-en.webp",
        [common_1.FormCategory.Sweepstakes]: "SweepstakesES.webp",
        [common_1.FormCategory.Auction]: "auction-form-mobile-preview-en.webp",
        [common_1.FormCategory.Shop]: "shop-form-mobile-preview-en.webp",
    },
    [locales_1.Locales.FR]: {
        [common_1.FormCategory.Event]: "event-form-mobile-preview-fr.webp",
        [common_1.FormCategory.DonationForm]: "donation-form-mobile-preview-fr.webp",
        [common_1.FormCategory.MembershipV2]: "membership-form-mobile-preview-fr.webp",
        [common_1.FormCategory.PeerToPeerCampaign]: "p2p-form-mobile-preview-fr.webp",
        [common_1.FormCategory.Custom]: "custom-form-mobile-preview-fr.webp",
        [common_1.FormCategory.Lottery]: "raffle-form-mobile-preview-fr.webp",
        [common_1.FormCategory.Sweepstakes]: "SweepstakesFR.webp",
        [common_1.FormCategory.Auction]: "auction-form-mobile-preview-fr.webp",
        [common_1.FormCategory.Shop]: "shop-form-mobile-preview-fr.webp",
    },
};
const getDesktopFormPreviewUrl = (locale, formCategory) => `${CLOUDINARY_BASE_DESKTOP}/${DESKTOP_FORM_PREVIEW_SLUGS[locale][formCategory]}`;
exports.getDesktopFormPreviewUrl = getDesktopFormPreviewUrl;
const getMobileFormPreviewUrl = (locale, formCategory) => `${CLOUDINARY_BASE_MOBILE}/${MOBILE_FORM_PREVIEW_SLUGS[locale][formCategory]}`;
exports.getMobileFormPreviewUrl = getMobileFormPreviewUrl;
const REGISTER_V4_S3_BASE_URL = "https://simplyk-bucket-production.s3.ca-central-1.amazonaws.com/register-v4";
const registerBackgroundLocaleSuffix = (locale) => locale === locales_1.Locales.ES ? "en" : locale.toLowerCase();
const getRegisterCategoryBackgroundImageUrl = (category, breakpoint, locale) => `${REGISTER_V4_S3_BASE_URL}/${category}/${breakpoint}-registration-background-${registerBackgroundLocaleSuffix(locale)}.jpg`;
exports.getRegisterCategoryBackgroundImageUrl = getRegisterCategoryBackgroundImageUrl;
const getRegisterDefaultBackgroundImageUrl = (breakpoint, locale) => `/images/internationalization/register/${breakpoint}-registration-background-${registerBackgroundLocaleSuffix(locale)}.jpg`;
exports.getRegisterDefaultBackgroundImageUrl = getRegisterDefaultBackgroundImageUrl;
exports.FromScratchEmailTemplatePreviewSvgUrl = "/images/internationalization/email-templates/from_scratch_email_template.svg";
exports.NewsletterCrossSellImageUrl = {
    [locales_1.Locales.EN]: "/images/internationalization/cross-sell/cross_sell_newsletter_en.webp",
    [locales_1.Locales.FR]: "/images/internationalization/cross-sell/cross_sell_newsletter_fr.webp",
    [locales_1.Locales.ES]: "/images/internationalization/cross-sell/cross_sell_newsletter_en.webp",
    [locales_1.Locales.DE]: "/images/internationalization/cross-sell/cross_sell_newsletter_de.webp",
};
exports.TipRefundHero100FreeImageUrl = {
    [locales_1.Locales.EN]: "/images/internationalization/tip-refund/refund-page-hero-100-free-EN.svg",
    [locales_1.Locales.FR]: "/images/internationalization/tip-refund/refund-page-hero-100-free-FR.svg",
    [locales_1.Locales.ES]: "/images/internationalization/tip-refund/refund-page-hero-100-free-FR.svg",
    [locales_1.Locales.DE]: "/images/internationalization/tip-refund/refund-page-hero-100-free-DE.svg",
};
exports.TipRefundTipModalImageUrl = {
    [locales_1.Locales.EN]: "/images/internationalization/tip-refund/refund-page-tip-modal-EN.svg",
    [locales_1.Locales.FR]: "/images/internationalization/tip-refund/refund-page-tip-modal-FR.svg",
    [locales_1.Locales.ES]: "/images/internationalization/tip-refund/refund-page-tip-modal-FR.svg",
    [locales_1.Locales.DE]: "/images/internationalization/tip-refund/refund-page-tip-modal-DE.svg",
};
exports.TipRefundWithZeffyImageUrl = {
    [locales_1.Locales.EN]: "/images/internationalization/tip-refund/refund-page-with-zeffy-EN.svg",
    [locales_1.Locales.FR]: "/images/internationalization/tip-refund/refund-page-with-zeffy-FR.svg",
    [locales_1.Locales.ES]: "/images/internationalization/tip-refund/refund-page-with-zeffy-FR.svg",
    [locales_1.Locales.DE]: "/images/internationalization/tip-refund/refund-page-with-zeffy-DE.svg",
};
exports.ShareFormLinkedButtonImageUrl = "/images/internationalization/share-form-modal/linked_button.svg";
exports.ShareFormEmbedImageUrl = "/images/internationalization/share-form-modal/form_embed.svg";
exports.ShareFormButtonPopupImageUrl = "/images/internationalization/share-form-modal/button_popup.svg";
